jQuery(document).ready(function($) {
    $(document).on('submit', 'form[data-xhr]', function (e) {
        e.preventDefault();

        var $form = $(this);
        var $container = $($form.data('xhr'));

        // submit the form using form method attribute and action attribute and put the response in the container
        $.ajax({
            url: $form.attr('action'),
            type: $form.attr('method'),
            data: $form.serialize(),
            beforeSend: function () {
                $container.trigger('pjax:start');
            },
            success: function (response) {
                $container.html(response);

                $container.trigger('pjax:complete');
            }
        });
    });
});
